<template>
  <div id="product-page">
    <module-renderer :moduleData="moduleData" />
  </div>
</template>

<script>
import { ref, provide, onMounted, onBeforeUnmount } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { IMAGE_SHOWCASE_OPACITY_KEY } from '@/components/modules/ImageShowcase/constants.js';

export default {
  name: 'Product',
  data() {
    return {
      loading: true,
      moduleData: []
    };
  },
  setup() {
    const imageShowcaseOpacity = ref(1);
    provide(IMAGE_SHOWCASE_OPACITY_KEY, imageShowcaseOpacity);

    let rafId = null;
    function updateScrollOpacity() {
      const top = typeof window !== 'undefined' ? window.scrollY : 0;
      const imageHeight = Math.min(240, window.innerWidth / 2);
      const opacity = Math.max(0, Math.min(1, 1 - (top / imageHeight) * 2));
      imageShowcaseOpacity.value = opacity;
    }
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        updateScrollOpacity();
        rafId = null;
      });
    }

    onMounted(() => {
      updateScrollOpacity();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll);
    });

    return { imageShowcaseOpacity };
  },
  computed: {
    ...mapGetters('assignments', { findAssignments: 'find' }),
    ...mapState(['offer']),
    imageShowcaseIdx() {
      return this.moduleData.findIndex(
        module => module.type === 'ImageShowcase'
      );
    }
  },
  methods: {
    ...mapActions('assignments', ['getAssignments'])
  },
  async created() {
    await this.getAssignments({
      assignmentId: parseInt(this.$route.params.productId, 10),
      dealId: parseInt(this.$route?.params?.dealId, 10) || 0,
      offerId: this.offer.id,
      type: 'product'
    });
    this.loading = false;

    const { productId: assignmentId } = this.$route.params;
    const assignment = this.findAssignments(assignmentId);
    this.moduleData = assignment.modules || [];
  }
};
</script>

<style lang="scss" scoped>
#product-page {
  min-height: 100%;
  padding-bottom: 93px;
  padding-top: min(240px, 100vw / 2);
}
</style>
